import { useState, useEffect } from "react";
import "./printing.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";
import { Modal } from "react-bootstrap";

function Printing() {
  const [data, setData] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [modalOrderDetails, setModalOrderDetails] = useState({});
  const [dispatchedQuantities, setDispatchedQuantities] = useState([]);
  const [newDispatchTo, setNewDispatchTo] = useState("");

  const getStatusColor = (status) => {
    switch (status) {
      case "Work completed":
        return "Green";
      case "Work in Progress":
        return "blue";
      case "Work Not Started ":
        return "red";
      default:
        return "";
    }
  };

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  const handleSaveClick = async () => {
    try {
      const hasFilledInput = data.some((order) =>
        order.updatedQuantity.some(
          (item) =>
            (item.isStatusChanged || item.inputValue !== undefined) &&
            (item.Currentstatus === "Work in Progress" ||
              (item.inputValue !== undefined && item.inputValue.trim() !== ""))
        )
      );

      if (!hasFilledInput) {
        alert("Please fill input before updating.");
        return;
      }

      const updatePromises = data.flatMap(async (order) => {
        return order.updatedQuantity.map(async (item) => {
          if (item.isStatusChanged || item.inputValue !== undefined) {
            const oldDispatchQuantity = item.DispatchQuantity || 0;
            const newDispatchQuantity = parseFloat(item.inputValue) || 0;
            const newDispatchto = newDispatchTo;

            const totalDispatchQuantity =
              oldDispatchQuantity + newDispatchQuantity;
            const payload = {
              DispatchQuantity: totalDispatchQuantity,
              Currentstatus: item.Currentstatus,
              newDispatchto,
            };

            if (newDispatchQuantity > 0) {
              payload.newQuantity = [newDispatchQuantity];
            }

            await Axios.put(
              `https://nodei.ssccglpinnacle.com/updateOrder/${order._id}/${item._id}`,
              payload
            );
          }
        });
      });

      await Promise.all(updatePromises);

      swal({
        title: "Data updated successfully",
        text: "",
        icon: "success",
      });
      window.location.reload();
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Error updating data. Please try again.");
    }
  };

  const handleInputChange = (event, orderIndex, itemIndex) => {
    const newData = [...data];
    newData[orderIndex].updatedQuantity[itemIndex].inputValue =
      event.target.value;
    setData(newData);
  };

  const handleBalance = (approvedQuantity, inputNumber) => {
    return approvedQuantity - inputNumber;
  };

  const handleCurrentstatusChange = (
    orderIndex,
    itemIndex,
    selectedCurrentstatus
  ) => {
    const newData = [...data];
    newData[orderIndex].updatedQuantity[itemIndex].Currentstatus =
      selectedCurrentstatus;
    setData(newData);
  };

  const handleDetailsButtonClick = (item) => {
    setModalOrderDetails(item);
    setShowDetailsModal(true);
    console.log(item);
  };

  const handleDispatchToChange = (selectedValue) => {
    setNewDispatchTo(selectedValue);
  };

  return (
    <div className="pipeline">
      <h3 style={{ textAlign: "center" }}>Create Printing Status</h3>

      <div style={{ width: "100%", overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            fontSize: "14px",
            whiteSpace: "nowrap",
          }}
        >
          <thead>
            <tr>
              {[
                "Order No",
                "PO Date",
                "Title",
                "Printing Price",
                "Dispatch To",
                "Change Status",
                "Dispatched Quantity",
                "Medium",
                "SKU",
                "Order Quantity",
                "Balance",
                "Action",
              ].map((heading, i) => (
                <th
                  key={i}
                  style={{
                    border: "1px solid #ccc",
                    padding: "6px 10px",
                    background: "#f9f9f9",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data &&
              data.map(
                (order, orderIndex) =>
                  order.updatedQuantity &&
                  order.updatedQuantity.map((item, itemIndex) => (
                    <tr key={`${order.orderid}-${itemIndex}`}>
                      {itemIndex === 0 && (
                        <>
                          <td
                            rowSpan={order.updatedQuantity.length}
                            style={{
                              border: "1px solid #ccc",
                              padding: "6px 10px",
                            }}
                          >
                            {order.orderid}
                          </td>
                          <td
                            rowSpan={order.updatedQuantity.length}
                            style={{
                              border: "1px solid #ccc",
                              padding: "6px 10px",
                            }}
                          >
                            {new Date(order.ApprovalDate).toLocaleDateString(
                              "en-US",
                              {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              }
                            )}
                          </td>
                        </>
                      )}

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={item.title}
                      >
                        {item.title}
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        {item.purchasePrice}
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        <select
                          defaultValue="Select"
                          onChange={(e) =>
                            handleDispatchToChange(
                              e.target.value,
                              orderIndex,
                              itemIndex
                            )
                          }
                          style={{
                            padding: "4px",
                            textAlign: "center",
                            fontSize: "12px",
                          }}
                        >
                          <option disabled>Select</option>
                          <option value="Pinnacle Civil Services">
                            Pinnacle Civil Services
                          </option>
                          <option value="Golden Peacock Publications">
                            Golden Peacock Publications
                          </option>
                        </select>
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        <select
                          value={
                            order.updatedQuantity[itemIndex].Currentstatus ||
                            "Work Not Started"
                          }
                          onChange={(e) => {
                            handleCurrentstatusChange(
                              orderIndex,
                              itemIndex,
                              e.target.value
                            );
                            setData((prevData) => {
                              const newData = [...prevData];
                              newData[orderIndex].updatedQuantity[
                                itemIndex
                              ].isStatusChanged = true;
                              return newData;
                            });
                          }}
                          style={{
                            padding: "4px",
                            textAlign: "center",
                            fontSize: "12px",
                            color: getStatusColor(
                              order.updatedQuantity[itemIndex].Currentstatus
                            ),
                          }}
                        >
                          <option disabled>Work Not Started</option>
                          <option value="Work in Progress">
                            Work in Progress
                          </option>
                          <option value="Work completed">Work completed</option>
                        </select>
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        <input
                          type="number"
                          value={item.inputValue || ""}
                          onChange={(e) =>
                            handleInputChange(e, orderIndex, itemIndex)
                          }
                          style={{
                            width: "70px",
                            padding: "4px",
                            textAlign: "center",
                            fontSize: "12px",
                          }}
                        />
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        {item.Medium}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        {item.sku}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        {item.approvedquantity}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        {item.Balance}
                      </td>

                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "6px 10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <button
                            onClick={handleSaveClick}
                            style={{
                              padding: "6px 12px",
                              fontSize: "13px",
                              cursor: "pointer",
                              border: "none",
                              borderRadius: "4px",
                              backgroundColor: "#4CAF50",
                              color: "white",
                              fontWeight: "500",
                              transition: "all 0.3s ease",
                            }}
                            onMouseOver={(e) =>
                              (e.target.style.backgroundColor = "#45a049")
                            }
                            onMouseOut={(e) =>
                              (e.target.style.backgroundColor = "#4CAF50")
                            }
                          >
                            Update
                          </button>

                          <button
                            onClick={() => handleDetailsButtonClick(item)}
                            style={{
                              padding: "6px 12px",
                              fontSize: "13px",
                              cursor: "pointer",
                              border: "none",
                              borderRadius: "4px",
                              backgroundColor: "#2196F3",
                              color: "white",
                              fontWeight: "500",
                              transition: "all 0.3s ease",
                            }}
                            onMouseOver={(e) =>
                              (e.target.style.backgroundColor = "#1976D2")
                            }
                            onMouseOut={(e) =>
                              (e.target.style.backgroundColor = "#2196F3")
                            }
                          >
                            Details
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
              )}
          </tbody>
        </table>
      </div>

      <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Order Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Title: {modalOrderDetails.title}</p>
          <p>SKU: {modalOrderDetails.sku}</p>
          <h5>Dispatch Quantity Details</h5>
          {modalOrderDetails.newQuantity && modalOrderDetails.newDispatchto ? (
            <ul>
              {modalOrderDetails.newQuantity.map((quantity, index) => (
                <li key={index}>
                  <p>
                    Dispatch Quantity ({index + 1}) ={" "}
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {quantity}
                    </span>{" "}
                    (
                    <span style={{ color: "blue", fontWeight: "bold" }}>
                      {modalOrderDetails.newDispatchto[index]}
                    </span>
                    )
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <p>No dispatch quantity details available</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDetailsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Printing;
